module.exports = __webpack_public_path__ + "media/images/BK_Grupo-802b566067308fa915bbb8b1e5227b5b.jpg";